import React, { Context, Dispatch, useReducer } from "react";

/**
 * Create a state provider
 */
export function createProvider<S, A>(
  stateContext: Context<S | undefined>,
  dispatchContext: Context<Dispatch<A> | undefined>,
  reducer: (state: S, action: A) => S,
  initialState: S
): React.FC<{ children?: React.ReactNode }> {
  return ({ children }) => {
    const [s, d] = useReducer(reducer, initialState);
    const state = React.useMemo(() => s, [s]);
    const dispatch = React.useMemo(() => d, [d]);

    return (
      <stateContext.Provider value={state}>
        <dispatchContext.Provider value={dispatch}>
          {children}
        </dispatchContext.Provider>
      </stateContext.Provider>
    );
  };
}
